export default __webpack_public_path__ + "static/media/i_wdt_c_3.ae4b5a93.mp3";